import { Card, CardContent } from "@/components/ui/card"
import { MousePointer, FileText, MessageSquare } from "lucide-react"
import { useLanguage } from "@/contexts/language-context"

export function HowItWorks() {
  const { t } = useLanguage()
  
  const steps = [
    {
      icon: MousePointer,
      title: t("howItWorks.step1.title"),
      description: t("howItWorks.step1.description"),
    },
    {
      icon: FileText,
      title: t("howItWorks.step2.title"),
      description: t("howItWorks.step2.description"),
    },
    {
      icon: MessageSquare,
      title: t("howItWorks.step3.title"),
      description: t("howItWorks.step3.description"),
    },
  ]

  return (
    <section id="how-it-works" className="py-24">
      <div className="container mx-auto px-4">
        <div className="text-center mb-20 animate-fade-in">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-100 dark:bg-indigo-900/30 rounded-full border border-purple-200 dark:border-purple-800/50 mb-8">
            <span className="text-sm font-medium text-purple-700 dark:text-purple-300">{t("howItWorks.badge")}</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-readable">
            {t("howItWorks.title")}
          </h2>
          <p className="text-xl text-muted-readable max-w-3xl mx-auto">
            {t("howItWorks.subtitle")}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 max-w-6xl mx-auto">
          {steps.map((step, index) => (
            <div key={index} className="text-center group">
              <Card className="hover-glow-card mb-8 transition-all duration-300 border-slate-200 dark:border-zinc-700 bg-white dark:bg-zinc-800/50">
                <CardContent className="p-10">
                  <div className="mx-auto mb-6 h-20 w-20 rounded-3xl bg-blue-100 dark:bg-indigo-700/30 flex items-center justify-center group-hover:bg-blue-400 dark:group-hover:bg-indigo-500 transition-all duration-300">
                    <step.icon className="h-10 w-10 text-blue-600 dark:text-indigo-400 group-hover:text-white" />
                  </div>
                  <div className="text-3xl font-bold text-blue-600 dark:text-indigo-400 mb-4">
                    {index + 1}
                  </div>
                </CardContent>
              </Card>
              <h3 className="text-2xl font-semibold mb-4 text-readable">{step.title}</h3>
              <p className="text-muted-readable text-lg leading-relaxed">{step.description}</p>
            </div>
          ))}
        </div>

        {/* Connection lines for desktop */}
        <div className="hidden md:block relative max-w-6xl mx-auto mt-16">
          <div className="absolute top-1/2 left-1/4 right-1/4 h-0.5 bg-gradient-to-r from-blue-200 via-blue-300 to-blue-200 dark:from-indigo-800 dark:via-indigo-700 dark:to-indigo-800 transform -translate-y-1/2"></div>
          <div className="absolute top-1/2 left-1/4 w-3 h-3 bg-blue-500 dark:bg-indigo-500 rounded-full transform -translate-y-1/2 -translate-x-1/2"></div>
          <div className="absolute top-1/2 left-1/2 w-3 h-3 bg-blue-500 dark:bg-indigo-500 rounded-full transform -translate-y-1/2 -translate-x-1/2"></div>
          <div className="absolute top-1/2 right-1/4 w-3 h-3 bg-blue-500 dark:bg-indigo-500 rounded-full transform -translate-y-1/2 translate-x-1/2"></div>
        </div>
      </div>
    </section>
  )
}
